export const MY_INFO = "/my-info";
export const LOS = "/los";
// export const LOS_DETAILS_INFO = "/los-details-info";
export const LOS_DETAILS_INFO = "/details-info";

export const LOS_SEARCH = "/los-search";
export const LOS_TREE_VIEW = "/los-tree-view";
export const LOS_BRANCH_VIEW = "/los-branch-view";
export const REPORTS = "/reports";
export const REPORTS_INFO = "/reports-info";
export const SETTINGS = "/settings";
export const EAGLE_TRACKER = "/eagle-tracker";
export const EAGLE_TRACKER_INFO = "/eagle-tracker-info";
